// el destino es lo que el usuario elige en el formulario; el origen es siempre el opuesto
export const getEtiquetasTraslado = (destinoEsConforme) => {
    return {
        labelDestino: destinoEsConforme
            ? "Producto conforme"
            : "Producto no conforme",

        labelOrigen: destinoEsConforme
            ? "Producto no conforme"
            : "Producto conforme",

        claseDestino: destinoEsConforme
            ? "traslado-control-calidad__group-header--conforme"
            : "traslado-control-calidad__group-header--no-conforme",

        claseOrigen: destinoEsConforme
            ? "traslado-control-calidad__group-header--no-conforme"
            : "traslado-control-calidad__group-header--conforme",

        colorTarjeta: destinoEsConforme ? "amarilla" : "roja",
    };
};
